export const isVideographerInvitation = (invite) =>
  String(invite?.type?.id) === '11'

export const isGameOfficialInvitation = (invite) =>
  String(invite?.type?.id) === '12'

export const isGameInvitation = (invite) =>
  isVideographerInvitation(invite) || isGameOfficialInvitation(invite)

export const resolveDisplayName = (inviterName, invite) =>
  invite?.display_destination?.name_full ||
  invite?.display_destination?.name ||
  inviterName ||
  ''

export const getInviteDisplayTitle = (inviterName, invite, t) => {
  if (isVideographerInvitation(invite)) {
    return 'Join The Game As A Videographer'
  }
  if (isGameOfficialInvitation(invite)) {
    return 'Join The Game As A Game Official'
  }
  return t('Web:joinTheX', {
    x: resolveDisplayName(inviterName, invite),
    interpolation: { escapeValue: false },
  })
}

export const getDestinationDisplayName = (removeTheFromName, invite) => {
  if (isGameInvitation(invite)) {
    return 'Game'
  }
  return resolveDisplayName(removeTheFromName, invite)
}
